<template>
  <v-form @submit.prevent="$emit('login')" class="d-flex justify-center flex-column" :class="!$vuetify.breakpoint.lgAndUp && ' px-0 mx-0'">
    <v-card-text class="d-flex flex-column align-center" :class="!$vuetify.breakpoint.lgAndUp && ' px-0 mx-0'">
      <p class="text-center">{{ $t('message.passwordResetAcknowledgement') }}</p>
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-stretch px-4 mt-4">
      <v-btn color="primary" class="mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" type="submit">{{ $t('label.login') }}</v-btn>
      <v-btn class="align-self-center primary--text" icon fab @click="$emit('prev-step')"><LeftArrow /></v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import LeftArrow from '@/assets/icons/left-arrow-circle.svg'

export default {
  components: { LeftArrow }
}
</script>
